var x, i, l;

x = document.getElementsByClassName("langswitch-select");
l = x.length;

for (i = 0; i < l; i++) {
  var selected = x[i].querySelector('.select-selected');
  var items = x[i].querySelector('.select-items');

  if (!selected || !items) continue;

  selected.addEventListener("click", function (e) {
    e.stopPropagation();
    closeAllSelect(this);
    this.nextElementSibling.classList.toggle("select-hide");
    this.classList.toggle("select-arrow-active");
  });
}

function closeAllSelect(elmnt) {
  var x, y, i, xl, yl, arrNo = [];
  x = document.getElementsByClassName("select-items");
  y = document.getElementsByClassName("select-selected");
  xl = x.length;
  yl = y.length;
  for (i = 0; i < yl; i++) {
    if (elmnt == y[i]) {
      arrNo.push(i);
    } else {
      y[i].classList.remove("select-arrow-active");
    }
  }
  for (i = 0; i < xl; i++) {
    if (arrNo.indexOf(i) === -1) {
      x[i].classList.add("select-hide");
    }
  }
}

document.addEventListener("click", closeAllSelect);
